import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/loginRegister/showEye.png'
import _imports_1 from '@/assets/loginRegister/hideEye.png'
import _imports_2 from '@/assets/themetwo/brazil_flag.png'
import _imports_3 from '@/assets/themetwo/lock.png'
import _imports_4 from '@/assets/loginRegister/email.png'


const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "sendOTP"
}
const _hoisted_5 = {
  key: 1,
  class: "sendOTP"
}
const _hoisted_6 = {
  key: 0,
  class: "leftContainer"
}
const _hoisted_7 = {
  key: 1,
  class: "leftContainer"
}
const _hoisted_8 = {
  key: 2,
  class: "leftContainer"
}

import { ref, watch } from 'vue'
import type { FieldType } from 'vant'
import { COUNT_DOWN_TIME, startCountdownCommon } from '@/view/loginRegister/supportScript'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
  fieldType: {
    type: String as () => FieldType,
    default: () => 'text'
  },
  isPassword: {
    type: Boolean,
    default: () => false
  },
  labelText: {
    type: String,
    default: () => ''
  },
  isshowFlag: {
    type: Boolean,
    default: () => false
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  isOTP: {
    type: Boolean,
    default: () => false
  },
  modelValue: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue','valueChanged', 'getOtp'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const isShow = ref(false)
const inputValue = ref(props.modelValue)
const countdown = ref(COUNT_DOWN_TIME)
const isCounting = ref(false)
const isLoading = ref(false)
let timer: ReturnType<typeof setInterval> | null = null
const emit = __emit


watch(() => props.modelValue, (newVal) => {
  inputValue.value = newVal
})

watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
  emit('update:modelValue', newValue) 
  emit('valueChanged', newValue)      
});

const handleShowPassword = () => {
  isShow.value = !isShow.value
}

const getOTP = () => {
  isLoading.value = true
  emit('getOtp')
}

const loadingFalse = () => {
  isLoading.value = false
}

let clearCountdown: (() => void) | null = null
const startCountdown = () => {
  clearCountdown?.()
  clearCountdown = startCountdownCommon(countdown, isCounting)
}
__expose({
  startCountdown,
  loadingFalse
})

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      "right-icon": "user-circle-o",
      style: _normalizeStyle({ border: props.isShowError ? '1.5px red solid' : '0.5px solid #65436f' }),
      type: isShow.value && props.isPassword ? 'text' : props.fieldType,
      maxlength: props.isPassword ? 20 : 'none',
      placeholder: props.labelText
    }, {
      "right-icon": _withCtx(() => [
        (props.isPassword)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (isShow.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_0,
                    alt: "",
                    width: "18px",
                    class: "iconImage",
                    onClick: handleShowPassword
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_1,
                    alt: "",
                    width: "18px",
                    class: "iconImage",
                    onClick: handleShowPassword
                  }))
            ]))
          : _createCommentVNode("", true),
        (props.isOTP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_van_loading, {
                      type: "spinner",
                      size: "15"
                    })
                  ]))
                : (isCounting.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(`${countdown.value}s`), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "sendOTP",
                      onClick: getOTP
                    }, _toDisplayString(_ctx.$t('loginRegister.sendCode')), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      "left-icon": _withCtx(() => [
        (!props.isPassword && props.isshowFlag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1),
              _createElementVNode("p", { class: "currencyText" }, "+55", -1)
            ])))
          : _createCommentVNode("", true),
        (props.isPassword)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "",
                width: "18px"
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        (props.fieldType == 'email')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "",
                width: "18px"
              }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "style", "type", "maxlength", "placeholder"])
  ]))
}
}

})